import apiClient from './api';
import API_ENDPOINTS from './endpoints';
class FavoritesService {
    /**
     * Obtiene los favoritos del usuario autenticado
     * Requiere token de autenticación
     */
    async getUserFavorites() {
        try {
            console.log('🔍 Favorites: Obteniendo favoritos del usuario desde:', API_ENDPOINTS.FAVORITES.BASE);
            const response = await apiClient.get(API_ENDPOINTS.FAVORITES.BASE);
            console.log('✅ Favorites: Respuesta recibida:', response);
            return response;
        }
        catch (error) {
            console.error('❌ Favorites: Error fetching user favorites:', error);
            // Si es un 404, la ruta no existe en el backend
            if (error && error.response && error.response.status === 404) {
                const customError = new Error('La ruta de favoritos no está disponible en el servidor. Por favor, verifica que el endpoint /api/favorites esté configurado.');
                customError.response = error.response;
                throw customError;
            }
            throw error;
        }
    }
    /**
     * Obtiene todos los favoritos populares (con favorites_count)
     * No requiere autenticación
     * La respuesta es Favorite[] con la misma estructura que getUserFavorites
     */
    async getAllFavorites() {
        try {
            console.log('🔍 Favorites: Obteniendo todos los favoritos desde:', API_ENDPOINTS.FAVORITES.ALL);
            const response = await apiClient.get(API_ENDPOINTS.FAVORITES.ALL);
            console.log('✅ Favorites: Respuesta recibida (todos los favoritos):', response);
            return response;
        }
        catch (error) {
            console.error('❌ Favorites: Error fetching all favorites:', error);
            // Si es un 404, la ruta no existe en el backend
            if (error && error.response && error.response.status === 404) {
                const customError = new Error('La ruta de favoritos populares no está disponible en el servidor. Por favor, verifica que el endpoint /api/favorites/all esté configurado.');
                customError.response = error.response;
                throw customError;
            }
            throw error;
        }
    }
    async addFavorite(locationId) {
        return apiClient.post(API_ENDPOINTS.FAVORITES.BASE, { location_id: locationId });
    }
    async removeFavorite(locationId) {
        return apiClient.delete(`${API_ENDPOINTS.FAVORITES.BASE}/${locationId}`);
    }
    /**
     * Transforma un favorito de la API al formato esperado por el componente
     */
    transformFavoriteToCard(favorite) {
        const location = favorite.location;
        if (!location) {
            throw new Error('El favorito no tiene una locacion asociada');
        }
        const mainImage = location.images?.find(img => img.is_main) || location.images?.[0];
        const imageUrl = mainImage?.image_url || '/images/placeholder.jpg';
        // Construir URL completa si es relativa
        const fullImageUrl = imageUrl.startsWith('http')
            ? imageUrl
            : `${String(process.env.VUE_APP_API_URL || '').replace(/\/$/, '')}/${imageUrl.replace(/^\//, '')}`;
        return {
            id: favorite.id,
            type: this.mapLocationTypeToFavoriteType(location.type),
            title: location.name,
            description: location.description,
            image: fullImageUrl,
            location: location.department?.name || location.address || '',
            category: location.department?.name || '',
            badge: location.badge || '',
            link: this.getLocationRoute(location),
            locationId: location.id,
            favoritesCount: location.favorites_count || 0,
            isTemporary: false
        };
    }
    /**
     * Mapea el tipo de location al tipo de favorito
     */
    mapLocationTypeToFavoriteType(type) {
        switch (type) {
            case 'restaurant':
                return 'gastronomy';
            case 'event':
                return 'events';
            case 'museum':
            case 'attraction':
            case 'city':
            case 'accommodation':
            default:
                return 'places';
        }
    }
    /**
     * Genera la ruta para una location
     */
    getLocationRoute(location) {
        const id = location.id;
        const type = location.type || 'attraction';
        switch (type) {
            case 'museum':
                return `/museo/${id}`;
            case 'city':
                return `/ciudad/${id}`;
            case 'restaurant':
                return `/location/${id}`;
            case 'accommodation':
                return `/hotel/${id}`;
            case 'attraction':
                return `/atractivo/${id}`;
            default:
                return `/location/${id}`;
        }
    }
}
export const favoritesService = new FavoritesService();
export default favoritesService;
